// src/pages/Login.js (Versão Simplificada e Focada)


import React, { useState, useCallback, useRef, useEffect } from 'react';

import { Link, useNavigate } from 'react-router-dom';

import { useAuth } from '../context/AuthContext';

import { useToast } from '../hooks/useToast';

import Particles from "react-tsparticles";

import { loadSlim } from "tsparticles-slim";
import { FaSpinner, FaTimes, FaEye, FaEyeSlash, FaChevronDown } from 'react-icons/fa';

import './Login.css';

import PublicOrgShowcase from '../components/public/PublicOrgShowcase';
import InstitutionalSignature from '../components/common/InstitutionalSignature/InstitutionalSignature';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { logAction } from '../utils/logger';

// Usando a nova logo animada do public
const logo = '/logo_gif.gif';

const ifesResultCards = [
    {
        value: '29% → 60%',
        label: 'evolução do iGG (2017 → 2021)',
        description: 'Avanço do indicador de governança do IFES após a adoção do Mago, passando de 29% em 2017 para 60% em 2021.',
    },
];

const ifesBenefits = [
    'Acompanhamento contínuo das ações de governança',
    'Registro estruturado das evidências e respostas',
    'Melhor interlocução entre setores e articuladores',
];

const particlesOptions = {

    background: { color: { value: '#F4F7F6' } }, // Cor de fundo clara da coluna esquerda

    fpsLimit: 60,

    interactivity: { events: { onHover: { enable: true, mode: 'repulse' } } },

    particles: {

        color: { value: '#A0AEC0' }, // Partículas mais escuras e sutis

        links: { color: '#CBD5E0', distance: 150, enable: true, opacity: 0.4, width: 1 }, // Links mais claros

        move: { direction: 'none', enable: true, outModes: { default: 'bounce' }, speed: 1 },

        number: { density: { enable: true, area: 800 }, value: 80 },

        opacity: { value: 0.5 },

        shape: { type: 'circle' },

        size: { value: { min: 1, max: 3 } },

    },

    detectRetina: true,

};



const Login = () => {

    const navigate = useNavigate();
    const showcaseRef = useRef(null);
    const scrollToShowcase = () => {
        if (showcaseRef.current) {
            showcaseRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const [email, setEmail] = useState('');

    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);



    const { login } = useAuth();

    // ✅ Função para pular a animação ao clicar
    const skipAnimation = () => {
        document.body.classList.remove('login-animation-active');
    };

    // Adiciona uma classe ao body para controlar a animação
    useEffect(() => {
        document.body.classList.add('login-animation-active');
        // Remove a classe quando o componente é desmontado (ao navegar para outra página)
        return () => document.body.classList.remove('login-animation-active');
    }, []);

    const { addToast } = useToast();



    const particlesInit = useCallback(async (engine) => {

        await loadSlim(engine);

    }, []);



    const handleSubmit = async (e) => {

        e.preventDefault();

        setLoading(true);

        try {

            const userCredential = await login(email, password);
            const userObj = userCredential?.user;
            if (userObj) {
                try {
                    const userDoc = await getDoc(doc(db, 'usuarios', userObj.uid));
                    if (userDoc.exists()) {
                        const userData = userDoc.data();
                        await logAction(
                            userObj.uid,
                            'Login no sistema',
                            { email: userObj.email, nome: userData.nome },
                            userObj.email,
                            userData.idOrganizacao || 'GLOBAL'
                        );
                    }
                } catch (logErr) {
                    console.error('Erro ao registrar log de login:', logErr);
                }
            }

        } catch (err) {

            console.error('[Login] Erro de autenticação:', err);

            const invalidCreds = [

                'auth/invalid-credential',

                'auth/user-not-found',

                'auth/wrong-password',

            ];

            if (invalidCreds.includes(err.code)) {

                addToast('Usuário ou senha incorretos', 'error');

            } else {

                addToast('Erro ao carregar, tente novamente', 'error');

            }

        } finally {

            setLoading(false);

        }

    };



    const [showExplainer, setShowExplainer] = useState(false);
    const [showMoreMobile, setShowMoreMobile] = useState(false);

    return (

        <div className="login-page-container">

            <section className="hero-section">

                <div className="login-institutional-banner">
                    <InstitutionalSignature variant="minimal" />
                </div>

                <div className="particles-left">
                    <Particles id="tsparticles" init={particlesInit} options={particlesOptions} />
                </div>

                <div className="hero-column-left" onClick={skipAnimation} role="button" tabIndex="0" aria-label="Pular animação de entrada">

                    <div className="storytelling">

                        <img src={logo} alt="Logo Mago" className="login-logo-main" />

                        <h1 className="headline">Gestão ESG que transforma, <span>resultados que impressionam.</span></h1>

                        <p className="support-text">
                            A plataforma que simplifica o monitoramento da gestão ESG, plenamente alinhada às diretrizes do TCU.
                        </p>

                        <button
                            type="button"
                            className="open-explainer-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                setShowExplainer(true);
                            }}
                        >
                            <i className="fas fa-info-circle"></i>
                            O que é o Mago e o iESGo?
                        </button>

                    </div>

                </div>

                {/* Modal Explicativo */}
                {showExplainer && (
                    <div className="mago-modal-overlay" onClick={() => setShowExplainer(false)}>
                        <div className="mago-modal-content" onClick={(e) => e.stopPropagation()}>
                            <button className="mago-modal-close" onClick={() => setShowExplainer(false)} aria-label="Fechar modal">
                                <FaTimes />
                            </button>

                            <header className="mago-modal-header">
                                <img src={logo} alt="Logo Mago" />
                                <h2>Entendendo o Ecossistema</h2>
                            </header>

                            <div className="mago-modal-body">
                                <section className="mago-section">
                                    <div className="mago-icon-box">
                                        <i className="fas fa-chart-line"></i>
                                    </div>
                                    <div className="mago-text">
                                        <h3>O que é o iESGo?</h3>
                                        <p>
                                            O <strong>Índice de Governança, Sustentabilidade e Gestão (iESGo)</strong> é o indicador oficial do <strong>TCU</strong> para avaliar a maturidade administrativa das organizações públicas brasileiras.
                                        </p>
                                        <p>
                                            Ele não é apenas uma nota; é um mapa que demonstra se a instituição segue os pilares de transparência, eficiência, controle social e sustentabilidade (ESG).
                                        </p>
                                    </div>
                                </section>

                                <section className="mago-section">
                                    <div className="mago-icon-box">
                                        <i className="fas fa-magic"></i>
                                    </div>
                                    <div className="mago-text">
                                        <h3>O que é o MAGO?</h3>
                                        <p>
                                            O <strong>MAGO</strong> é a solução tecnológica definitiva para a gestão desse índice, desenvolvida para transformar dados complexos em decisões inteligentes.
                                        </p>
                                        <ul>
                                            <li><strong>Monitoramento em Tempo Real:</strong> Acompanhe o progresso de cada tema ESG sem precisar aguardar o fim do ciclo.</li>
                                            <li><strong>Descentralização:</strong> Permite que diferentes articuladores colaborem e anexem evidências de forma organizada e segura.</li>
                                            <li><strong>Cálculo Automático:</strong> Aplica o rigor técnico exigido pelo Tribunal para validar a conformidade da sua instituição.</li>
                                        </ul>
                                    </div>
                                </section>

                                <section className="mago-impact-section">
                                    <div className="mago-impact-copy">
                                        <span className="mago-impact-kicker">Impacto no IFES</span>
                                        <h3>Resultados concretos em governança pública</h3>
                                        <p>
                                            Com o apoio do Mago, o IFES fortaleceu o monitoramento das ações de governança e alcançou melhora expressiva nos indicadores avaliados pelo TCU.
                                        </p>
                                    </div>
                                    <div className="mago-impact-grid">
                                        {ifesResultCards.map((item) => (
                                            <div className="mago-impact-card" key={item.label}>
                                                <strong>{item.value}</strong>
                                                <span>{item.label}</span>
                                            </div>
                                        ))}
                                    </div>
                                </section>

                                <div className="mago-modal-footer">
                                    <p>
                                        Enquanto o <strong>iESGo</strong> define onde sua instituição deve chegar, o <strong>MAGO</strong> oferece os meios para garantir que esse caminho seja trilhado com precisão e excelência.
                                    </p>
                                </div>
                            </div>

                            <div className="mago-modal-actions">
                                <button className="mago-primary-btn" onClick={() => setShowExplainer(false)}>Entendi, obrigado!</button>
                            </div>
                        </div>
                    </div>
                )}



                <div className="hero-column-right">
                    <div className="login-form-wrapper">
                        <div className="login-form-panel">

                            <h2>Acesse sua plataforma</h2>

                            <form onSubmit={handleSubmit}>

                                <div className="input-group">
                                    <label htmlFor="email">E-mail</label>
                                    <input
                                        type="email"
                                        id="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="seu.email@instituicao.gov.br"
                                        required
                                        autoComplete="email"
                                    />
                                </div>
                                <div className="input-group">

                                    <label htmlFor="password">Senha</label>

                                    <div className="password-input-wrapper">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            id="password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            placeholder="********"
                                            required
                                            autoComplete="current-password"
                                        />
                                        <button
                                            type="button"
                                            className="password-toggle-btn"
                                            onClick={() => setShowPassword(!showPassword)}
                                            aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                                            title={showPassword ? "Ocultar senha" : "Mostrar senha"}
                                        >
                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                        </button>
                                    </div>
                                </div>

                                <div className="login-options">

                                    <div className="remember-me">
                                        <label className="checkbox-item" htmlFor="remember">
                                            <input type="checkbox" id="remember" />
                                            <span>Lembrar-me</span>
                                        </label>
                                    </div>

                                    <Link to="/recuperar-senha" className="support-link">Esqueceu sua senha?</Link>

                                </div>

                                <Link to="/acessar-por-link" className="support-link login-magic-link-entry">
                                    É Alta Gestão? Acesse por link enviado ao seu e-mail
                                </Link>

                                <button type="submit" className="login-button" disabled={loading} aria-busy={loading}>
                                    {loading ? (
                                        <>
                                            <FaSpinner className="icon-spin" />
                                            <span>Entrando...</span>
                                        </>
                                    ) : (
                                        'Entrar'
                                    )}
                                </button>

                                <button
                                    type="button"
                                    className="login-more-toggle"
                                    onClick={() => setShowMoreMobile((v) => !v)}
                                    aria-expanded={showMoreMobile}
                                    aria-controls="login-secondary-actions">
                                    Saiba mais
                                    <FaChevronDown className={`login-more-chevron ${showMoreMobile ? 'open' : ''}`} aria-hidden="true" />
                                </button>

                                <div id="login-secondary-actions" className={`login-secondary-actions ${showMoreMobile ? 'open' : ''}`}>

                                    <div className="divider">ou</div>

                                    <button
                                        type="button"
                                        className="public-diagnostics-button login-secondary-explainer"
                                        onClick={() => setShowExplainer(true)}
                                        aria-label="Abrir explicação sobre o Mago e o iESGo">
                                        <i className="fas fa-info-circle"></i>
                                        O que é o Mago e o iESGo?
                                    </button>

                                    <button

                                        type="button"

                                        className="public-diagnostics-button"

                                        onClick={scrollToShowcase}

                                        aria-label="Ir para os diagnósticos públicos">
                                        <i className="fas fa-chart-line login-diag-icon"></i>
                                        Ver diagnósticos públicos
                                    </button>

                                    <button
                                        type="button"
                                        className="rede-federal-button"
                                        onClick={() => navigate('/rede-federal')}
                                        aria-label="Abrir o portal da Rede Federal no Mago">
                                        <i className="fas fa-graduation-cap"></i>
                                        Rede Federal no Mago
                                    </button>

                                </div>
                            </form>

                        </div>
                    </div>

                    {/* Copyright e Registro */}
                    <footer className="login-footer-credits">
                        <p>© {new Date().getFullYear()} MAGO — Monitoramento de Ações de Governança.</p>
                        <p className="ip-process-tag">Registro INPI: BR512024001217-6</p>
                    </footer>
                    {/* fecha hero-column-right */}
                </div>

            </section>


            <div className="public-diagnostics-wrapper">
                <section className="ifes-results-section" aria-labelledby="ifes-results-title">
                    <div className="ifes-results-header">
                        <span className="ifes-results-kicker">Resultados alcançados no IFES</span>
                        <h2 id="ifes-results-title">O Mago ajudou a transformar governança em resultado mensurável.</h2>
                        <p>
                            A plataforma apoiou o IFES no controle das ações de governança, na organização das evidências e no acompanhamento dos indicadores avaliados pelo TCU.
                        </p>
                    </div>

                    <div className="ifes-results-grid">
                        {ifesResultCards.map((item) => (
                            <article className="ifes-result-card" key={item.label}>
                                <strong>{item.value}</strong>
                                <span>{item.label}</span>
                                <p>{item.description}</p>
                            </article>
                        ))}
                    </div>

                    <div className="ifes-benefits-panel">
                        {ifesBenefits.map((benefit) => (
                            <div className="ifes-benefit-item" key={benefit}>
                                <i className="fas fa-check-circle" aria-hidden="true"></i>
                                <span>{benefit}</span>
                            </div>
                        ))}
                    </div>
                </section>

                <section ref={showcaseRef} className="public-diagnostics-section">
                    <div className="section-title-container">
                        <button type="button" className="back-to-top-btn" onClick={scrollToTop} aria-label="Voltar ao topo (Login)">
                            <i className="fas fa-arrow-up" /> Voltar ao topo
                        </button>
                        <h2 className="public-diagnostics-title">Explorador de Diagnósticos Públicos</h2>
                        <p className="section-subtitle">Navegue pelos resultados de organizações que optaram pela transparência.</p>
                    </div>
                    <PublicOrgShowcase />
                </section>
            </div>

        </div>

    );

};



export default Login;
